module.exports = __webpack_public_path__ + "img/uganda.4ce82391.png";